// extracted by mini-css-extract-plugin
export default {"hero":"Home_hero__IU09S","titleContainer":"Home_titleContainer__D9kw3","title":"Home_title__Bfc6A","subtitle":"Home_subtitle__SrHuY"};